module.exports = __webpack_public_path__ + "img/skip-back.abd4d2cd.svg";